import { stateInfo } from "@/constants/version-state";
import { cn } from "@/lib/utils";

// Read-only version-state badge. See DESIGN.md "State badge".
export const StateBadge = ({
  state,
  className,
}: {
  state: number;
  className?: string;
}) => {
  const s = stateInfo(state);
  return (
    <span
      className={cn(
        "shrink-0 rounded px-1.5 py-0.5 text-xs font-medium",
        s?.color || "bg-muted text-muted-foreground",
        className,
      )}
    >
      {s?.label ?? state}
    </span>
  );
};

export default StateBadge;
